/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('backbone'));
    } else if (typeof define === 'function' && define.amd) {
        define(['backbone'], factory);
    }
})(this, function (Backbone) {
    'use strict';

    return Backbone.Model.extend({
        getFeatures: function () {
            var canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d'),
                // A text string that contains ASCII, punctuation, emoji,
                // extended-Latin, CJK, and unrenderable unicode characters.
                // Breadth of symbology here increases variability accross
                // devices.
                txt =
                    'EBjsFp <.,+*~ \u263A\u5E0C\u30B8\u0416\u0950\u266C\uAA2C',
                data,
                padding,
                hash;

            // A complicated drawing consisting of above text, a rectangle,
            // and a filled bezier curve with some amount of transparency.
            // different devices mix the colors differently.
            canvas.height = 50;
            ctx.textBaseline = 'top';
            ctx.font = '18px "Arial"';
            ctx.textBaseline = 'alphabetic';
            ctx.fillStyle = '#f65';
            ctx.fillRect(33, 7, 205, 8.1);
            ctx.fillStyle = 'rgba(241, 50, 212, .7)';
            ctx.moveTo(5, 19);
            ctx.bezierCurveTo(20, -20, 60, 49, 117, 2.2);
            ctx.fill();
            ctx.fillStyle = '#069';
            ctx.fillText(txt, 2, 15);
            ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
            ctx.fillText(txt, 4, 17);

            // Calculate the hash of the canvas RGB data. The canvas data is
            // dumped as a base64 encoded PNG. A CRC of the image data is
            // included in the end of the IDAT (penultimate) chunk of a PNG.
            // The IEND (last) chunk of PNG is always 12 bytes long, so the
            // CRC is 12th to 16th byte from the end, or 16th to 22th byte
            // when base64 encoded depending on padding.
            data = canvas.toDataURL();
            padding = data.match(/=*$/)[0].length;
            hash =
                '' +
                padding +
                data.substring(
                    data.length - 22 - padding,
                    data.length - 16 - padding,
                );

            return [hash];
        },
    });
});
